export interface SuccessStory {
  quote: string;
  author: string;
}

export const successStories: SuccessStory[] = [
  {
    quote:
      "Avanse helped me pursue my MBA at ISB.Their quick processing and competitive interest rates made my dream possibe",
    author: "Priya Sharma",
  },
  {
    quote:
      "Thanks to Avanse's study abroad loan, I completed my MS in Computer Science from Stanford University.",
    author: "Rahul Gupta",
  },
  {
    quote:
      "The flexible repayment options from Avanse allowed me to focus on my medical studies without financial stress.",
    author: "Sanjeev Patel",
  },
];
